import type { TPageId } from "routes/route";

/**
 * Intentionally duplicated from routes.tsx (order matters: first match wins):
 * importing routes.tsx here would pull every lazy page into the dependency
 * graph of everything that uses pageContext, defeating Chromatic TurboSnap.
 * A unit test derives this list from routes.tsx and fails if the two drift.
 */
export type TPageMatch = { matches: string[]; pageId: TPageId };

export const pageMatches: TPageMatch[] = [
  { matches: ["/accessReport", "/accessReport/:accessReviewId"], pageId: "AccessReport" },
  { matches: ["/accessReport/resources/:resourceId"], pageId: "ResourceAccessReport" },
  { matches: ["/accessReport/subordinates/:subordinateId"], pageId: "SubordinateAccessReport" },
  { matches: ["/accessReport/:accessReviewId/resources/:resourceId"], pageId: "ResourceAccessReport" },
  { matches: ["/accessReport/:accessReviewId/subordinates/:subordinateId"], pageId: "SubordinateAccessReport" },
  { matches: ["/accessReview"], pageId: "AccessReview" },
  { matches: ["/accessReview/resources/:resourceId"], pageId: "AdminResourceAccessReview" },
  { matches: ["/accessReview/subordinates/:subordinateId"], pageId: "AdminSubordinateAccessReview" },
  { matches: ["/accessReview/reports/:reportId"], pageId: "AccessReviewReport" },
  { matches: ["/accessReview/templates"], pageId: "AccessReviewTemplatesPage" },
  { matches: ["/accessReview/templates/create"], pageId: "AccessReviewTemplatePage" },
  { matches: ["/accessReview/templates/edit/:templateId"], pageId: "AccessReviewTemplatePage" },
  { matches: ["/auditLogs"], pageId: "AuditLogs" },
  { matches: ["/bulkActions"], pageId: "BulkActions" },
  { matches: ["/bundles"], pageId: "Bundles" },
  { matches: ["/"], pageId: "Home" },
  { matches: ["/permissions", "/graph"], pageId: "Permissions" },
  { matches: ["/integrations"], pageId: "Integrations" },
  { matches: ["/integrations/create"], pageId: "CreateIntegration" },
  { matches: ["/integrations/:integrationId"], pageId: "Integration" },
  { matches: ["/integrations/:integrationId/resources/:integrationResourceId"], pageId: "IntegrationResource" },
  { matches: ["/integrations/:integrationId/resources/:integrationResourceId/roles/:integrationResourceRoleId"], pageId: "IntegrationResourceRole" },
  { matches: ["/newRequest"], pageId: "NewRequest" },
  { matches: ["/policies"], pageId: "Policies" },
  { matches: ["/profile"], pageId: "Profile" },
  { matches: ["/reporting"], pageId: "Reporting" },
  { matches: ["/requests"], pageId: "Requests" },
  { matches: ["/requests/myPermissions"], pageId: "MyPermissions" },
  { matches: ["/requests/past"], pageId: "PastRequests" },
  { matches: ["/requestHistory"], pageId: "RequestsLog" },
  { matches: ["/rules"], pageId: "Rules" },
  { matches: ["/rules/create"], pageId: "RulesCreate" },
  { matches: ["/rules/edit/:ruleId"], pageId: "RulesEdit" },
  { matches: ["/organizationSettings"], pageId: "Settings" },
  { matches: ["/organizationSettings/directoryConfiguration/:idpType/:idpId?"], pageId: "DirectoryConfigurationPage" },
  { matches: ["/tasks"], pageId: "Tasks" },
  { matches: ["/users"], pageId: "Users" },
  { matches: ["/users/jitAnalysis"], pageId: "JitAnalysis" },
  { matches: ["/users/:userId"], pageId: "User" },
  { matches: ["/workflows"], pageId: "Workflows" },
  { matches: ["/workflows/create"], pageId: "CreateWorkflow" },
  { matches: ["/workflows/edit/:workflowId"], pageId: "EditWorkflow" },
  { matches: ["/workflows/webhooks"], pageId: "WorkflowsWebhooks" },
];
